/**
 * Разбирает значение селекта сортировки вида `<field>_<direction>` по последнему `_`:
 * поле может само содержать подчёркивания (например, `created_at_desc`).
 */
export function parseSortValue<TField extends string = string>(
  value: string
): [TField, 'asc' | 'desc'] {
  const idx = value.lastIndexOf('_')
  return [value.slice(0, idx) as TField, value.slice(idx + 1) as 'asc' | 'desc']
}
